import { Divider, Skeleton, Stack, styled, Typography } from "@mui/material";

const SKELETON_WIDTHS = ["52%", "60%", "85%", "49%", "58%"];

export const FilterSectionSkeleton = ({ amount }: { amount: number }) => {
  return (
    <Stack>
      {Array.from({ length: amount }).map((_, index) => (
        <div key={index}>
          <Divider />
          <SingleFilterSkeleton skeletonWidth={SKELETON_WIDTHS[index % SKELETON_WIDTHS.length]} />
        </div>
      ))}
      <Divider />
    </Stack>
  );
};

const SingleFilterSkeleton = styled(({ skeletonWidth, ...props }: { className?: string; skeletonWidth: string }) => {
  return (
    <div {...props}>
      <Typography variant="titleMedium">
        <Skeleton width={skeletonWidth} />
      </Typography>
    </div>
  );
})({
  padding: "16px",
});
